const customImageListStyles = {
    root: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-evenly",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        overflow: "auto",
    },
    imageList: {
        display: "flex",
        gridGap: "10px",
        margin: "0 auto",
        transform: "translateZ(0)",
    },
};

export default customImageListStyles;
